
import Banner from "../components/banner/Banner";
import Footer from "../components/footer/Footer";

import Navbar from "../components/navbar/Navbar";

import { useEffect } from "react";
import Refund from "../components/refundpolicy/Refund";


const RefundPolicy=()=>{
      useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
    return(
        <div className="">
<Navbar/>
 <Banner title="Refund policy"/>

<Refund/>
<Footer/>

</div>
    )
}
export default RefundPolicy;